import { defineComponent as _defineComponent } from 'vue'
import {ref} from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const height = ref(document.documentElement.clientHeight);// 可见区域高度(应为body高度，可某些环境下无法获取)


return { __sfc: true,height }
}

})